import EventBus from 'CORE/bus'
import _ from 'lodash'

export default {
    inserted: function(el, { value, modifiers }) {
        if (_.get(modifiers, 'mouse', false)) {
            el.addEventListener('mouseenter', _ => EventBus.$emit('SHOW_HELP', value))
            el.addEventListener('mouseleave', _ => EventBus.$emit('SHOW_HELP', false))
        }
        if (_.get(modifiers, 'focus', false)) {
            el.addEventListener('focus', _ => EventBus.$emit('SHOW_HELP', value))
            el.addEventListener('blur', _ => EventBus.$emit('SHOW_HELP', false))
        }
    },
}
